import React, { useContext, useEffect, useState } from 'react'
import { isEmpty, get, uniqueId } from 'lodash'
import BookPage from './page'
import { BookInfo } from '../../contexts/menuContext'
import { getPages } from '../../api/getPage'
import MaterialsMain from './MaterialMain'

const BookMaterials = () => {
  const [book, , page] = useContext(BookInfo)
  const [content, setContent] = useState(null)
  useEffect(() => {
    if (get(book, 'childrenMenu', true)) {
      setContent(null)
    } else if (get(book, 'page_type') === 'materials' && page) {
      getPages([page], book).then((data) => {
        if (data) {
          setContent(data[0])
        }
      })
    } else {
      setContent(null)
    }
  }, [page, book])

  return (
    <div className="book-materials">
      <div className="book">
        {!isEmpty(content) && get(content, 'type') === 'supplement_type_list' ?
          <BookPage key={get(content, 'id', false) ? content.id : `rand_${uniqueId()}`} item={content} /> :
          <MaterialsMain/>}
      </div>
    </div>
  )
}

export default BookMaterials
